module.exports = __webpack_public_path__ + "static/media/Basement.cf28d705.png";